import React, { useState, useEffect } from 'react';
import { Typography, Row, Col } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import { VertContainer, VertLoading } from '@vertem-core/vertice-ds';
import { useDispatch, useSelector } from "react-redux";
import WinnerCard from './WinnerCard';
import { Pagination } from 'antd';
import { getWinners } from 'redux/Reducers/PopBallon/VertemGiftApi';

const WinnersShowcase = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [isEmpty, setIsEmpty] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const { winners } = useSelector(state => state.VertemGift);
    const itemsPerPage = 10;

    const filteredWinners = winners.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    useEffect(() => {
        dispatch(getWinners()).then(() => {
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        if (winners.length > 0) {
            setIsEmpty(false);
        } else {
            setIsEmpty(true);
        }
    }, [winners]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <VertContainer>
            {isLoading && (
                <Row className='extract-page-loading' align='middle' justify='center' gutter={6}>
                    <VertLoading type="spin" size='small' />
                </Row>
            )}

            {isEmpty && !isLoading && (
                <Row className='extract-page-empty' align='middle' justify='center' gutter={6}>
                    <Col className='col'>
                        <Typography.Title level={3} style={{ textAlign: 'center' }}>
                            Você ainda não resgatou nenhum balão de aniversário
                        </Typography.Title>
                        <Typography.Paragraph style={{ textAlign: 'center' }}>
                            Venha participar da nossa promoção!
                        </Typography.Paragraph>
                    </Col>
                </Row>
            )}

            {!isLoading && !isEmpty && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    {filteredWinners.map(item => (
                        <WinnerCard
                            key={item.id}
                            productName={item.skuName}
                            name={item.participantName}
                            city={item.participantCity}
                            state={item.participantUf}
                            date={item.createdAt}
                        />
                    ))}

                    {winners.length > itemsPerPage && (
                        <Pagination
                            current={currentPage}
                            total={winners.length}
                            pageSize={itemsPerPage}
                            onChange={handlePageChange}
                            style={{ marginTop: '20px' }}
                        />
                    )}
                </div>
            )}
        </VertContainer>
    );
};

export default WinnersShowcase;
